/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_System_HubspotInputs */

const en_mapping_system_hubspot = /** @type {(inputs: Mapping_System_HubspotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HubSpot`)
};

/**
* | output |
* | --- |
* | "HubSpot" |
*
* @param {Mapping_System_HubspotInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_system_hubspot = /** @type {((inputs?: Mapping_System_HubspotInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_System_HubspotInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_system_hubspot(inputs)
});